import React from 'react';
import { motion } from 'framer-motion';

/** 기본: fade + 살짝 scale (홈·편집·폼 등) */
const fadeVariants = {
  initial: { opacity: 0, y: 14,  scale: 0.99 },
  animate: { opacity: 1, y: 0,   scale: 1    },
  exit:    { opacity: 0, y: -10, scale: 0.99  },
};

/** 리스트 페이지: 아래에서 슥 올라오는 느낌 */
const slideUpVariants = {
  initial: { opacity: 0, y: 60 },
  animate: { opacity: 1, y: 0  },
  exit:    { opacity: 0, y: 30 },
};

const springTransition = { type: 'spring' as const, stiffness: 300, damping: 28 };
const slideTransition  = { type: 'spring' as const, stiffness: 280, damping: 26 };

export type PageVariant = 'fade' | 'slideUp';

interface PageTransitionProps {
  children: React.ReactNode;
  variant?: PageVariant;
  style?: React.CSSProperties;
}

export const PageTransition: React.FC<PageTransitionProps> = ({
  children,
  variant = 'fade',
  style,
}) => (
  <motion.div
    variants={variant === 'slideUp' ? slideUpVariants : fadeVariants}
    initial="initial"
    animate="animate"
    exit="exit"
    transition={variant === 'slideUp' ? slideTransition : springTransition}
    style={{
      position: 'fixed',
      inset: 0,
      width: '100%',
      height: 'var(--app-height, 100dvh)',
      overflow: 'hidden',
      ...style,
    }}
  >
    {children}
  </motion.div>
);

export default PageTransition;
